export default __webpack_public_path__ + "72815c7c4bc8771be4e612c15ee66e6f.webp";